import React from 'react';
import { WeekdayPropTypes } from 'react-day-picker';

const Weekday = function({ weekday, className, localeUtils, locale }) {
  const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);

  return (
    <div className={ className } title={ weekdayName }>
      { weekdayName.slice(0, 3) }
    </div>
  );
};

Weekday.propTypes = WeekdayPropTypes;

export default Weekday;



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_Weekday.jsx